<template>
    <div class="col-md-12">
        <div class="ln_solid"></div>
        <br />
        <form @submit.prevent="searchData()" role="form">
            <div class="row">
                <div class="col-2">

                    <input type="text"
                           class="form-control"
                           v-model="pagingInfo.search"
                           placeholder="Subject/Title" />

                </div>
                <div class="col-2">

                    <input type="date"
                           class="form-control"
                           v-model="pagingInfo.datestart"
                           placeholder="Date Start" />

                </div>
                <div class="col-2">

                    <input type="date"
                           class="form-control"
                           v-model="pagingInfo.dateend"
                           placeholder="Date End" />

                </div>
                <div class="col-2">

                    <input type="text"
                           class="form-control"
                           v-model="pagingInfo.reportnumber"
                           placeholder="Report Number" />

                </div>
                
                <div class="col-2">

                    <button type="submit" class="btn btn-info">
                        <strong>Search</strong>
                    </button>
                    &nbsp;
                    <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>
                </div>
            </div>
        </form>
        <br />

        <div class="box">
            <div class="box-header"></div>
            <div class="box-body table-responsive no-padding">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <!--<th>ID</th>-->
                            <th>Subject</th>
                            <th>Report No.</th>
                            <th>Report Date</th>
                            <th>Created By</th>
                            <th>Date Created</th>
                            <th>Updated By</th>
                            <th>Date Updated</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="doc in documents" :key="doc.id">
                            <!--<td><p ng-hide="doc.n4sh == 'Y'">{{doc.id}}</td>-->
                            <td>{{ doc.title | capitalize }}</td>
                            <td>{{ doc.reportNo }}</td>
                            <td>{{ doc.reportDate | formatDate }}</td>
                            <td>{{ doc.createdBy }}</td>
                            <td>{{ doc.dateCreated | formatDate }}</td>
                            <td>{{ doc.updatedBy }}</td>
                            <td>{{ doc.dateUpdated | formatDate }}</td>
                            <td>
                                <TheDropDownButton>
                                    <btn @click.native="editDocument(doc.id)"
                                         icon="fa fa-pencil-alt"
                                         title="Edit"></btn>
                                    <btn @click.native="preview(doc.id)"
                                         icon="fa fa-search"
                                         title="Preview File Attached"></btn>
                                    <btn @click.native="getfile(doc.id)"
                                         icon="fa fa-download"
                                         title="Download File"></btn>
                                    <btn @click.native="More(doc)"
                                         icon="fa fa-expand-alt"
                                         title="View Linkages"></btn>
                                    <btn @click.native="startLink(doc)"
                                         icon="fa fa-compress"
                                         title="Enable Link Mode"></btn>
                                </TheDropDownButton>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot></tfoot>
                </table>
                <div v-show="totalitems == 0" class="alert alert-warning">
                    <p>Found no result try again</p>
                </div>
            </div>
        </div>
        <b-pagination v-model="pagingInfo.page"
                      v-on:input="fetchData()"
                      :total-rows="totalitems"
                      :per-page="pagingInfo.itemsPerPage"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"></b-pagination>
        <b-modal id="DocEdit"
                 title="Document Edit"
                 size="lg"
                 scrollable
                 hide-footer>
            <DocEdit v-bind:id="DocumentID" v-on:done-edit="doneEdit()" />
        </b-modal>
        <b-modal id="editatt"
                 title="Change Attached Document"
                 scrollable
                 hide-footer
                 size="md">
            <attach v-bind:id="DocumentID"
                    v-bind:url="urlAttach"
                    v-on:done-edit-att="doneEditAtt()" />
        </b-modal>
        <b-modal id="linkpopupmy"
                 title="View Links"
                 size="xl"
                 scrollable
                 hide-footer>
            <linkpop v-bind:id="linkid" v-bind:linkdescription="linkdescription" />
        </b-modal>
        <b-modal id="previewMY"
                 title="Preview"
                 scrollable
                 hide-footer
                 size="xl">
            <viewerMY v-bind:Id="idforviewer"
                    v-bind:html="htmlforviewer" />
        </b-modal>
    </div>
</template>

<script>
    import { authHeader, responseCheck, RecordURL, downloadblob, DataURL, notifyHelper } from "../helper";
    import DocEdit from "../components/edit/Document";
    import attach from "./master/editAttachment";
    import btn from "./buttons/iconButton";
    import instance from "../helper/http";
    import linkpop from "./link/linkcomponent";
    import viewerMY from "./master/viewer";
    export default {
        data() {
            return {
                documents: [],
                pagingInfo: {
                    page: 1,
                    sortBy: "DateCreated",
                    reverse: false,
                    search: "",
                    reportnumber: "",
                    datestart: "",
                    dateend: "",
                },
                totalitems: null,
                dataType: "",
                DocumentID: "",
                urlAttach: "editAttachment",
                htmlforviewer: "",
                idforviewer: "",
            };
        },
        components: {
            DocEdit,
            attach,
            btn,
            linkpop,
            viewerMY
        },
        methods: {
            fetchData() {
                instance
                    .get(RecordURL + "getdocregiondata", {
                        headers: authHeader(),
                        params: this.pagingInfo,
                    })
                    .then((response) => {
                        this.documents = response.data.data;
                        this.totalitems = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            searchData() {
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            More: function (data) {
                var additional = data.title;
                additional = additional.replace(/\//g, "-");
                this.linkid = data.id;
                this.linkdescription = additional;
                this.$bvModal.show("linkpopupmy");
            },
            sort: function (sortBy) {
                if (sortBy === this.pagingInfo.sortBy) {
                    this.pagingInfo.reverse = !this.pagingInfo.reverse;
                } else {
                    this.pagingInfo.sortBy = sortBy;
                    this.pagingInfo.reverse = false;
                }
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            preview(id) {
                instance
                    .get(DataURL + "preview?Id=" + id, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        if (!response.data.error) {
                            this.idforviewer = id;
                            this.htmlforviewer = response.data.data;
                            this.$bvModal.show("previewMY");
                        } else {
                            notifyHelper("info", response.data.message);
                        }
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            download: function (docID, filename, type) {
                //window.open(RecordURL + 'downloadcopy?docID=' + docID, '_blank', '')
                instance
                    .get(RecordURL + "downloadcopy?docID=" + docID, {
                        headers: authHeader(),
                        responseType: "blob",
                    })
                    .then((response) => {
                        downloadblob(filename, response.data, type);
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            getfile: function (id) {
                instance
                    .get(RecordURL + "checkfiles?docID=" + id, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        if (response.data.withfiles) {
                            this.download(id, response.data.filename, response.data.type);
                        } else {
                            this.getFullText(id);
                        }
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            startLink: function (doc) {
                this.$bvModal
                    .msgBoxConfirm("Are you sure you want to enable link mode?.", {
                        title: "Enable Link Mode?",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "success",
                        okTitle: "Yes",
                        cancelTitle: "No",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            this.$store.commit("enablelinkMode", {
                                id: doc.id,
                                type: "DC",
                                description: doc.title,
                            });
                        }
                    });
            },
            getFullText(id) {
                instance
                    .get(RecordURL + "fulltext?docID=" + id, {
                        headers: authHeader(),
                        responseType: "blob",
                    })
                    .then((response) => {
                        downloadblob(id + ".pdf", response.data, "application/pdf");
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            editDocument: function (doc) {
                this.DocumentID = doc;
                //modal
                this.$bvModal.show("DocEdit");
            },
            doneEdit() {
                this.$bvModal.hide("DocEdit");
            },
            editAttach: function (doc) {
                this.DocumentID = doc;
                //modal
                this.$bvModal.show("editatt");
            },
            doneEditAtt() {
                this.$bvModal.hide("editatt");
            },
            clearControls() {

                this.pagingInfo.search = "";
                this.pagingInfo.reportnumber = "";
                this.pagingInfo.datestart = "";
                this.pagingInfo.dateend = "";
            },
        },
    };
</script>
